/* eslint-disable */
// @ts-nocheck

const gtmSnippet = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-K4BXFWM');`;

export const loadGtag = (defaultConsentValue? = "denied") => {
  if (typeof window.gtag === "undefined") {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }

    window.gtag = gtag;

    gtag("consent", "default", {
      ad_storage: defaultConsentValue,
      ad_user_data: defaultConsentValue,
      ad_personalization: defaultConsentValue,
      analytics_storage: defaultConsentValue,
    });

    const script = document.createElement("script");
    script.innerText = gtmSnippet;
    document.head.appendChild(script);
  }
};

export const loadFacebookPixel = (...ids: string[]) => {
  if (typeof window.fbq === "undefined") {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    fbq("init", "587073223839077");
    fbq("track", "PageView");
  }
};

const claritySnippet = `
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "p0hb9wm98k");`;

const tiktokSnippet = `!function (w, d, t) {
w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
ttq.load('D5590EJC77U9GK0PEM8G');
ttq.page();
}(window, document, 'ttq');`;

export const loadClarity = () => {
  if (typeof window.clarity === "undefined") {
    const script = document.createElement("script");
    script.innerText = claritySnippet;
    document.head.appendChild(script);
  }
};

export const loadTiktokPixel = () => {
  if (typeof window.ttq === "undefined") {
    const script = document.createElement("script");
    script.innerText = tiktokSnippet;
    document.head.appendChild(script);
  }
};

export const googleTag = (...args: any[]) => {
  if (typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

/* eslint-enable */
